import { ui } from '../ui';

/** Простой поп-ап поверх страницы — закрывается по клику на фон. */
export default function Modal({ onClose, width = 420, children }) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(6,10,22,0.6)', zIndex: 1000,
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '10vh 24px',
      }}
    >
      <div onClick={e => e.stopPropagation()} style={{ ...ui.card, width, maxWidth: '100%', marginBottom: 0 }}>
        {children}
      </div>
    </div>
  );
}
